import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

export const MainContent = styled(Box)<{ sidebarOpen?: boolean }>(({ theme, sidebarOpen = true }) => ({
  position: 'relative',
  right: 0,
  top: 0,
  width: '100%',
  padding: theme.spacing(3),
  transition: 'all 0.3s ease',
  backgroundColor: '#E7EFF5',
  height: '100%',
  minHeight: 'calc(100vh - 72px)',
  maxHeight: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  boxSizing: 'border-box',
  '& .MuiContainer-root': {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    width: '100%',
    boxSizing: 'border-box',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

export const OverviewContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '8px',
  padding: theme.spacing(2),
  maxWidth: '100%',
  margin: '0 auto',
  width: '100%',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}));

export const TableSection = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: '120px',
  height: '30px',
  borderRadius: '1000px',
  padding: '0 24px',
  backgroundColor: '#00ACE7',
  color: '#FFFFFF',
  border: 'none',
  fontSize: '11px',
  fontWeight: 600,
  textTransform: 'uppercase',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#0095C7',
    boxShadow: 'none',
  },
  '&:disabled': {
    backgroundColor: '#B8C4CE',
    color: '#6C757D',
    boxShadow: 'none',
  }
}));

export const ViewButton = styled(Button)(({ theme }) => ({
  minWidth: '32px',
  height: '32px',
  borderRadius: '4px',
  padding: '6px 12px',
  backgroundColor: '#00ACE7',
  color: '#FFFFFF',
  border: 'none',
  fontSize: '12px',
  fontWeight: 500,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#0095C7',
    boxShadow: 'none',
  },
  '&:disabled': {
    backgroundColor: '#B8C4CE',
    color: '#6C757D',
    boxShadow: 'none',
  }
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  minWidth: '32px',
  height: '32px',
  borderRadius: '4px',
  padding: '6px 12px',
  backgroundColor: '#4CAF50',
  color: '#FFFFFF',
  border: 'none',
  fontSize: '12px',
  fontWeight: 500,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#45A049',
    boxShadow: 'none',
  },
  '&:disabled': {
    backgroundColor: '#B8C4CE',
    color: '#6C757D',
    boxShadow: 'none',
  }
}));

export const DeleteButton = styled(Button)(({ theme }) => ({
  minWidth: '32px',
  height: '32px',
  borderRadius: '4px',
  padding: '6px 12px',
  backgroundColor: '#F44336',
  color: '#FFFFFF',
  border: 'none',
  fontSize: '12px',
  fontWeight: 500,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#D32F2F',
    boxShadow: 'none',
  },
  '&:disabled': {
    backgroundColor: '#B8C4CE',
    color: '#6C757D',
    boxShadow: 'none',
  }
}));

export const ActionButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex', 
  flexDirection: 'column', 
  gap: 2, 
  width: '100%', 
  maxWidth: '1250px',
  margin: '0 auto',
  overflow: 'hidden'
})); 